import { useEffect, useState } from 'react';
import {
  subscribe,
  claimSlot,
  releaseSlot,
  ownsSlot,
} from '../lib/pwa/bottomBannerSlot';

// Reivindica o slot de banner do rodapé enquanto `active` for true e retorna se
// ESTE banner é o dono (maior prioridade ativa). Use assim:
//
//   const owns = useBottomBannerSlot(wantsToShow, 'pwa-update', 2);
//   if (!wantsToShow || !owns) return null;
//
// Prioridades maiores vencem. Libera no unmount.
export function useBottomBannerSlot(
  active: boolean,
  key: string,
  priority: number,
): boolean {
  const [, force] = useState(0);
  useEffect(() => subscribe(() => force((n) => n + 1)), []);
  useEffect(() => {
    if (active) claimSlot(key, priority);
    else releaseSlot(key);
    return () => releaseSlot(key);
  }, [active, key, priority]);
  return active && ownsSlot(key);
}
